import React from "react";
import { useEffect, useState } from "react";
import { UrlApi } from "../../../services/apirest";
import { Container, Box, Grid, Typography, Stack, Button, IconButton, FormControl, InputLabel, Select, MenuItem, TextField } from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { grey } from "@mui/material/colors";
import InputAdornment from "@mui/material/InputAdornment";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import ContactMailIcon from "@mui/icons-material/ContactMail";
import ContactPhoneIcon from "@mui/icons-material/ContactPhone";
import BadgeIcon from "@mui/icons-material/Badge";
import Alerta from "../../Alerta";
import Notify from "../../Notify";
import ContactsIcon from "@mui/icons-material/Contacts";
import PushPinIcon from "@mui/icons-material/PushPin";

export default function Editardireccion(props) {
    const [datosformulario, setDatosformulario] = useState(props.datos);
    const [clientes, setClientes] = useState(null);
    const [localidades, setLocalidades] = useState(null);
    const [rutas, setRutas] = useState(null);
    const [provincias, setProvincias] = useState(null);
    const [sucursales, setSucursales] = useState(null);
    const [disBtn, setDisBtn] = useState(false);
    const [openSnack, setOpenSnack] = React.useState(false);
    const [colormensaje, setColorMensaje] = useState("");
    const [mensaje, setMensaje] = useState("");
    const [notificacion, setNotificacion] = useState(false); //define si se muestra o no una notificación (snackbar)
    const [error, setError] = useState(null); //guardará el error que lance la api (si existe)
    const [mensajeAlerta, setMensajeAlerta] = useState(""); //mensaje que contendrá el componente "alerta"
    const [finalizar, setFinalizar] = useState(); //finalizar === 1 lo manda como prop el componente "notify" e indica que la transaccion ha finalizado y debe ejecutarse la funcion para cerrar
    const [severityAlerta, setSeverityAlerta] = useState(""); //define severidad de la alerta (success error o warning)
    const [severitySnack, setSeveritySnack] = useState(""); //define severidad del snackbar (notificación)
    const [productos, setProductos] = useState(null);

    const almacenar = (e) => {
        setDatosformulario({
            ...datosformulario,
            [e.target.name]: e.target.value,
        });
    };

    const obtenerClientes = () => {
        fetch(UrlApi + "/clientes") //fetch con la urp de api q esta en services/apirest + la ruta
            .then((data) => data.json()) //mando los datos que recibo en json
            .then((data) => setClientes(data)); //seteo Sucursales
    };

    const obtenerLocalidades = () => {
        fetch(UrlApi + "/localidades/prov/" + datosformulario.id_provincia)
            .then((data) => data.json())
            .then((data) => setLocalidades(data));
    };

    const obtenerSuc = () => {
        fetch(UrlApi + "/sucursales") //fetch con la urp de api q esta en services/apirest + la ruta
            .then((data) => data.json()) //mando los datos que recibo en json
            .then((data) => setSucursales(data)); //seteo Sucursales
    };


    const obtenerRutas = () => {
        fetch(UrlApi + "/rutas/suc/" + datosformulario.id_sucursal) //fetch con la urp de api q esta en services/apirest + la ruta
            .then((data) => data.json()) //mando los datos que recibo en json
            .then((data) => setRutas(data)); //seteo Sucursales
    };

    const obtenerProvincias = () => {
        fetch(UrlApi + "/provincias") //fetch con la urp de api q esta en services/apirest + la ruta
            .then((data) => data.json()) //mando los datos que recibo en json
            .then((data) => setProvincias(data)); //seteo Sucursales
    };

    const obtenerProductos = () => {
        fetch(UrlApi + '/productos?solo_activos=1')
            .then(data => data.json())
            .then(async (data) => {
                const lista = Array.isArray(data) ? data : [];
                const idActual = datosformulario.id_producto;
                const esta = lista.some((p) => String(p.idproducto ?? p.id) === String(idActual));
                if (idActual && !esta) {
                    const todos = await fetch(UrlApi + "/productos").then((r) => r.json());
                    const actual = (Array.isArray(todos) ? todos : []).find(
                        (p) => String(p.idproducto ?? p.id) === String(idActual)
                    );
                    setProductos(actual ? [...lista, actual] : lista);
                    return;
                }
                setProductos(lista);
            })
    };

    useEffect(() => {
        obtenerClientes();
        obtenerProvincias();
        obtenerSuc();
        obtenerProductos();
    }, []);

    useEffect(() => {
        obtenerRutas();
    }, [datosformulario.id_sucursal])


    useEffect(() => {
        obtenerLocalidades();
    }, [datosformulario.id_provincia]);

    const handleClose = () => {
        props.tabla(true);
        props.editar(false);
    };

    //Funcion para guardar la direccion de entrega
    const guardarDireccion = async (e) => {
        setDisBtn(true)
        e.preventDefault();
        const response = await fetch(UrlApi + "/direccionesentrega/" + datosformulario.id, {
            method: "PUT",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
                direccion_entrega: datosformulario.direccion_entrega,
                contacto: datosformulario.contacto,
                telefono1: datosformulario.telefono1,
                telefono2: datosformulario.telefono2,
                telefono3: datosformulario.telefono3,
                mails: datosformulario.mails,
                latitud: datosformulario.latitud,
                longitud: datosformulario.longitud,
                id_cliente: datosformulario.id_cliente,
                id_localidad: datosformulario.id_localidad,
                id_ruta: datosformulario.id_ruta,
                id_provincia: datosformulario.id_provincia,
                usuario: localStorage.getItem("user"),
                nombre_direccion: datosformulario.nombre_direccion,
                id_sucursal: datosformulario.id_sucursal,
                id_producto:datosformulario.id_producto
            }),
        })//response&&console.log(response)
        if (response.ok === false) {
            console.log("ERROR EN API");
            const error = response && response.json();
            setError(error);
            setSeverityAlerta("error")
            setMensajeAlerta("Inconvenientes con la API. No se pudo guardar. ");
        } else {
            console.log("Conexión con api OK");
            try {
                //Parseo respuesta de la api a json()
                const json = await response.json();
                //si api me devuelve lo q le puse en message
                if (json.message) {
                    //Si ese mensaje es "OK"
                    if (json.message === "OK") {
                        console.log("Guardado Satisfactoriamente");
                        setNotificacion(true);
                        setOpenSnack(true);
                        setColorMensaje("#D4EFDF");
                        setMensaje("Guardado");
                        setSeveritySnack("success");
                    } else {
                        console.log("res en api incorrecto. Revisar que sea 'OK'")
                        setNotificacion(true);
                        setOpenSnack(true);
                        setColorMensaje("#D4EFDF");
                        setSeveritySnack("error");
                        setMensaje("Registro Guardado. REVISAR RESPUESTA DE API (E_S)");
                    }
                } else if (json.sqlMessage) {
                    json && setError(json);
                    console.log(json);
                    setMensajeAlerta("SQL erróneo (" + json.code + " Errno: " + json.errno + " )");
                } else {
                    setMensajeAlerta("ERROR DESCONOCIDO.");
                }
            } catch (error) {
                if (error.toString().includes("is not valid JSON")) {
                    console.log("Guardado. Advertencia: Actualizar respuesta de api. JSON invalido.");
                    setNotificacion(true);
                    setOpenSnack(true);
                    setColorMensaje("#D4EFDF");
                    setMensaje("Guardado");
                    setSeveritySnack("success");
                } else {
                    setMensajeAlerta("ERROR DESCONOCIDO.");
                }
            }
        }
    };

    const style = {
        backgroundColor: "#ffffff",
        width: "100%"
    };

    return (
        <div>
            <Container>
                <Box sx={{ flexGrow: 1 }}>
                    <Grid container backgroundColor="#1F618D" p={1.5}>
                        <Grid item xs={2}>
                            <IconButton onClick={handleClose}>
                                <ArrowBackIcon sx={{ color: grey[50] }} />
                            </IconButton>
                        </Grid>
                        <Grid
                            item
                            xs={8}
                            container
                            direction="row"
                            justifyContent="center"
                            alignItems="center"
                        >
                            <Typography variant="h5" color="#ffffff">
                                Editar direccion de entrega
                            </Typography>
                        </Grid>
                    </Grid>
                </Box>
                <form onSubmit={guardarDireccion}>
                    <Box backgroundColor="#F4F6F6"
                        mt={2}
                        p={3}
                        border={0.5}
                        borderColor={"#ABB2B9"}
                        borderRadius={4}
                    >
                        <Grid container spacing={1} direction={{ xs: 'column', sm: 'row' }}>
                            <Grid item xs={12}>
                                <FormControl fullWidth style={style} color="primary" focused>
                                    <InputLabel>Cliente</InputLabel>
                                    <Select
                                        label="Cliente"
                                        required
                                        name="id_cliente"
                                        labelId="id_cliente"
                                        value={datosformulario.id_cliente}
                                        onChange={almacenar}
                                    >
                                        {clientes
                                            ? clientes.map((elemento) => (
                                                <MenuItem key={elemento.id} value={elemento.id}>
                                                    {elemento.razon_social}
                                                </MenuItem>
                                            ))
                                            : null}
                                    </Select>
                                </FormControl>
                            </Grid>
                            <Grid item xs={6}>
                                <FormControl fullWidth style={style} focused margin="dense">
                                    <InputLabel id="demo-simple-select-helper-label">
                                        Provincia
                                    </InputLabel>
                                    <Select
                                        required
                                        name="id_provincia"
                                        labelId="id_provincia"
                                        value={datosformulario.id_provincia}
                                        label="Provincia"
                                        onChange={almacenar}
                                    >
                                        {provincias
                                            ? provincias.map((elemento) => (
                                                <MenuItem key={elemento.id} value={elemento.id}>
                                                    {elemento.provincia}
                                                </MenuItem>
                                            ))
                                            : null}
                                    </Select>
                                </FormControl>
                            </Grid>
                            <Grid item xs={6}>
                                <FormControl fullWidth style={style} focused margin="dense">
                                    <InputLabel id="demo-simple-select-helper-label">
                                        Localidad
                                    </InputLabel>
                                    <Select
                                        focused
                                        required
                                        name="id_localidad"
                                        label="Localidad"
                                        value={datosformulario.id_localidad}
                                        onChange={almacenar}
                                    >
                                        {localidades
                                            ? localidades.map((elemento) => (
                                                <MenuItem key={elemento.id} value={elemento.id}>
                                                    {elemento.localidad}
                                                </MenuItem>
                                            ))
                                            : null}
                                    </Select>
                                </FormControl>
                            </Grid>
                            <Grid item xs={6}>
                                <FormControl fullWidth style={style} focused margin="dense">
                                    <InputLabel id="demo-simple-select-helper-label">
                                        Sucursal
                                    </InputLabel>
                                    <Select
                                        focused
                                        required
                                        name="id_sucursal"
                                        label="Sucursal"
                                        value={datosformulario.id_sucursal}
                                        onChange={almacenar}
                                    >
                                        {sucursales
                                            ? sucursales.map((elemento) => (
                                                <MenuItem key={elemento.id} value={elemento.id}>
                                                    {elemento.nombre}
                                                </MenuItem>
                                            ))
                                            : null}
                                    </Select>
                                </FormControl>
                            </Grid>
                            <Grid item xs={6}>
                                <FormControl fullWidth style={style} focused margin="dense">
                                    <InputLabel id="demo-simple-select-helper-label">Ruta</InputLabel>
                                    <Select
                                        required
                                        name="id_ruta"
                                        value={datosformulario.id_ruta}
                                        label="Ruta"
                                        onChange={almacenar}
                                    >
                                        {rutas
                                            ? rutas.map((elemento) => (
                                                <MenuItem key={elemento.id} value={elemento.id}>
                                                    {elemento.nombre}
                                                </MenuItem>
                                            ))
                                            : null}
                                    </Select>
                                </FormControl>
                            </Grid>
                            <Grid item xs={6}>
                                <TextField
                                    placeholder="Ejemplo: Casa Central"
                                    type="text"
                                    required
                                    margin="dense"
                                    focused
                                    fullWidth
                                    style={style}
                                    name="nombre_direccion"
                                    id="nombre_direccion"
                                    label="Punto de entrega"
                                    color="primary"
                                    onChange={almacenar}
                                    value={datosformulario.nombre_direccion}
                                    InputProps={{
                                        startAdornment: (
                                            <InputAdornment position="start">
                                                <BadgeIcon />
                                            </InputAdornment>
                                        ),
                                    }}
                                /></Grid>
                            <Grid item xs={6}>
                                <TextField
                                    placeholder="Direccion de entrega"
                                    type="text"
                                    required
                                    focused
                                    style={style}
                                    margin="dense"
                                    fullWidth
                                    name="direccion_entrega"
                                    id="direccion_entrega"
                                    label="Direccion de entrega"
                                    color="primary"
                                    onChange={almacenar}
                                    value={datosformulario.direccion_entrega.replace(/\b\w/g, (l) =>
                                        l.toUpperCase()
                                    )}
                                    inputProps={{ maxLength: 200 }}
                                    InputProps={{
                                        startAdornment: (
                                            <InputAdornment position="start">
                                                <LocationOnIcon />
                                            </InputAdornment>
                                        ),
                                    }}
                                />
                            </Grid>
                            <Grid item xs={6}>
                                <TextField
                                    placeholder="Sr .. "
                                    style={style}
                                    type="text"
                                    focused
                                    margin="dense"
                                    fullWidth
                                    name="contacto"
                                    id="contacto"
                                    label="Contacto"
                                    color="primary"
                                    onChange={almacenar}
                                    value={datosformulario.contacto}
                                    inputProps={{ maxLength: 200 }}
                                    InputProps={{
                                        startAdornment: (
                                            <InputAdornment position="start">
                                                <ContactsIcon />
                                            </InputAdornment>
                                        ),
                                    }}
                                />
                            </Grid>
                            <Grid item xs={6}>
                                <FormControl fullWidth style={style} focused margin="dense">
                                    <InputLabel id="demo-simple-select-helper-label">Producto</InputLabel>
                                    <Select
                                        required
                                        name="id_producto"
                                        value={datosformulario.id_producto}
                                        label="Producto"
                                        onChange={almacenar}
                                    >
                                        {productos
                                            ? productos.map((elemento) => (
                                                <MenuItem key={elemento.id} value={elemento.id}>
                                                    {elemento.nombre}
                                                </MenuItem>
                                            ))
                                            : null}
                                    </Select>
                                </FormControl>
                            </Grid>
                            <Grid item xs={4}>
                                <TextField
                                    type="number"
                                    focused
                                    style={style}
                                    fullWidth
                                    margin="dense"
                                    name="telefono1"
                                    id="telefono1"
                                    label="Telefono 1"
                                    color="primary"
                                    onChange={almacenar}
                                    value={datosformulario.telefono1}
                                    InputProps={{
                                        startAdornment: (
                                            <InputAdornment position="start">
                                                <ContactPhoneIcon />
                                            </InputAdornment>
                                        ),
                                    }}
                                />
                            </Grid>
                            <Grid item xs={4}>
                                <TextField
                                    type="number"
                                    margin="dense"
                                    focused
                                    fullWidth
                                    name="telefono2"
                                    id="telefono2"
                                    label="Telefono 2"
                                    color="primary"
                                    style={style}
                                    onChange={almacenar}
                                    value={datosformulario.telefono2}
                                    InputProps={{
                                        startAdornment: (
                                            <InputAdornment position="start">
                                                <ContactPhoneIcon />
                                            </InputAdornment>
                                        ),
                                    }}
                                />
                            </Grid>
                            <Grid item xs={4}>
                                <TextField
                                    type="number"
                                    focused
                                    fullWidth
                                    style={style}
                                    name="telefono3"
                                    margin="dense"
                                    id="telefono3"
                                    label="Telefono 3"
                                    color="primary"
                                    onChange={almacenar}
                                    value={datosformulario.telefono3}
                                    InputProps={{
                                        startAdornment: (
                                            <InputAdornment position="start">
                                                <ContactPhoneIcon />
                                            </InputAdornment>
                                        ),
                                    }}
                                />
                            </Grid>
                            <Grid item xs={12}>
                                <TextField
                                    placeholder="ejemplo@mail.com"
                                    type="email"
                                    focused
                                    fullWidth
                                    name="mails"
                                    id="mails"
                                    style={style}
                                    label="Mails"
                                    color="primary"
                                    margin="dense"
                                    onChange={almacenar}
                                    value={datosformulario.mails}
                                    inputProps={{ maxLength: 300 }}
                                    InputProps={{
                                        startAdornment: (
                                            <InputAdornment position="start">
                                                <ContactMailIcon />
                                            </InputAdornment>
                                        ),
                                    }}
                                /></Grid>
                            <Grid item xs={6}>
                                <TextField
                                    placeholder="Latitud"
                                    style={style}
                                    focused
                                    fullWidth
                                    margin="dense"
                                    name="latitud"
                                    id="latitud"
                                    label="Latitud"
                                    color="primary"
                                    //helperText="Latitud Incorrecta"
                                    onChange={almacenar}
                                    value={datosformulario.latitud}
                                    inputProps={{ maxLength: 45 }}
                                    InputProps={{
                                        startAdornment: (
                                            <InputAdornment position="start">
                                                <PushPinIcon />
                                            </InputAdornment>
                                        ),
                                    }}
                                />
                            </Grid>
                            <Grid item xs={6}>
                                <TextField
                                    placeholder="Longitud"
                                    focused
                                    fullWidth
                                    style={style}
                                    name="longitud"
                                    margin="dense"
                                    id="longitud"
                                    label="Longitud"
                                    color="primary"
                                    onChange={almacenar}
                                    value={datosformulario.longitud}
                                    inputProps={{ maxLength: 45 }}
                                    InputProps={{
                                        startAdornment: (
                                            <InputAdornment position="start">
                                                <PushPinIcon />
                                            </InputAdornment>
                                        ),
                                    }}
                                />
                            </Grid>
                            <Grid mt={2} container direction="row" justifyContent="space-between" alignItemns="center">
                                <Button disabled={disBtn} variant="contained" color="error" onClick={handleClose}>
                                    Volver
                                </Button>
                                <Button disabled={disBtn} variant="contained" color="success" type="submit">
                                    Guardar Direccion
                                </Button>
                            </Grid>
                        </Grid>
                    </Box>
                    {notificacion ? (
                        <Notify
                            mensaje={mensaje}
                            open={openSnack}
                            color={colormensaje}
                            finalizar={setFinalizar}
                            severity={severitySnack}
                        />
                    ) : null}
                    {/* ALERT --> SE MUESTRA SI HAY UN ERROR EN LA API (NO SE CONECTA O ESTÁ MAL LA RUTA, ETC.) */}
                    {error && mensajeAlerta ? (
                        <Alerta mensaje={mensajeAlerta} severity={severityAlerta} />
                    ) : null}
                </form>
            </Container>
            <br></br>
            <br></br>
            <br></br>
        </div>
    );


}
